
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/payment/complete",
      function () {
        return require("private-next-pages/payment/complete.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/payment/complete"])
      });
    }
  